module.exports = __webpack_public_path__ + "static/img/gift-card.a1800622.png";